import.meta.globEager('@/assets/images/**/*.{jpg,jpeg,png}', {
	query: { format: 'webp', quality: 80 },
});

import { vars } from './config/variables';

import {
	disableScroll,
	enableScroll,
	getDeviceType,
	classInstance,
} from '@/shared/helpers/helpers';

import { Form } from '@/shared/form/form';

import { debounce } from '@/shared/utils/utils';

window.app = {};
window.vars = vars;

window.app.classInstance = classInstance;
window.app.disableScroll = disableScroll;
window.app.enableScroll = enableScroll;
window.app.getDeviceType = getDeviceType;

window.app.Form = Form;

window.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.js-form').forEach((element) => new Form(element));
});

/* Initial app settings */
import { applyInitialSettings } from '@/shared/utils/utils';
applyInitialSettings();

/* Header related logic */
import InitHeaderSearch from '@/features/search/header-search/header-search';
import InitNavDrawer from '@/shared/nav-drawer/nav-drawer';
import { setCatalogHeight, setCatalogDropdownLinks } from '@/features/catalog/catalog';
import { initStickyHeader } from '@/widgets/header/header';

new InitHeaderSearch();
new InitNavDrawer();
setCatalogHeight();
setCatalogDropdownLinks();
initStickyHeader();

/* Dropdowns */
import { Dropdown } from '@/shared/common/dropdown/dropdown';

const dropdowns = document.querySelectorAll('.js-dropdown:not([data-dropdown="mobile"])');
const mobileDropdowns = document.querySelectorAll('.js-dropdown[data-dropdown="mobile"]');
const mobileDropdownsInstances = [];
const laptopMQ = window.matchMedia(`(min-width: ${window.vars.breakpoint.laptop}px)`);

dropdowns.forEach((dropdown) => {
	new Dropdown(dropdown);
});
mobileDropdowns.forEach((dropdown) => {
	mobileDropdownsInstances.push(dropdown);
	if (!laptopMQ.matches) {
		new Dropdown(dropdown);
	}
});

laptopMQ.addEventListener('change', () => {
	mobileDropdownsInstances.forEach((dropdown) => {
		if (laptopMQ.matches) {
			window.app.classInstance.get(dropdown)?.dropdown.destroy();
		} else {
			new Dropdown(dropdown);
		}
	});
});

/* Collapse */
import { Collapse } from '@/shared/common/collapse/collapse';
document.querySelectorAll('.js-collapse:not(.js-testimonials-container)').forEach((element) => {
	new Collapse(element, { mode: element.dataset?.mode, duration: element.dataset?.duration });
});

/* Modals */
import { Modal } from '@/shared/modal/modal';
document.querySelectorAll('.js-modal').forEach((element) => {
	new Modal(element);
});

/* Forms' logic */
window.addEventListener('DOMContentLoaded', () => {
	const applicationModal = document.querySelector('.js-modal-application');
	const applicationFormElSelector = 'js-application-form';
	const subscribeForm = document.querySelector('.js-subscribe-form-container');
	const subscribeFormElSelector = 'js-subscribe-form';
	const subscribeFormElement =
		subscribeForm && subscribeForm.querySelector(`.${subscribeFormElSelector}`);

	/* Forms' demo logic */
	document.querySelectorAll('.js-demo-form').forEach(($form) => {
		const $button = $form.querySelector('button[type="submit"]');
		const instance = app.classInstance.get($form);
		$button.addEventListener('click', (event) => {
			event.preventDefault();
			if (!instance.form.formCheck(false)) return;
			if (instance.form.$form.classList.contains(subscribeFormElSelector)) {
				if (subscribeForm) {
					const form = subscribeForm.querySelector('form');
					form.classList.add('has-sent');
					subscribeForm.querySelector('form').innerHTML =
						'<div class="h3">Спасибо, что подписались!</div>';
				}
			}
			if (instance.form.$form.classList.contains(applicationFormElSelector)) {
				applicationModal.classList.add('has-success');
				if (applicationModal)
					applicationModal.querySelector('.modal-window__title').innerHTML =
						'Спасибо <br>за обращение!';
				applicationModal.querySelector('.js-modal__content').innerHTML =
					'<div class="modal-window__success">Мы свяжемся с вами <br>в ближайшее время</div>';
			}
			console.log('submit');
		});
	});

	/* New forms validation */
	// document.querySelectorAll('.omb-template .js-form').forEach(($form) => {
	// 	const $button = $form.querySelector('button[type="submit"]');
	// 	const instance = app.classInstance.get($form);
	// 	$button.addEventListener('click', (event) => {
	// 		event.preventDefault();
	// 		if (!instance.form.formCheck(false)) return;
	// 		console.log('submit');
	// 	});
	// });

	/* Animate subscribe form disappearance */
	subscribeFormElement &&
		subscribeFormElement.style.setProperty(
			'--form-height',
			`${subscribeFormElement.scrollHeight}px`,
		);

	subscribeFormElement &&
		window.addEventListener(
			'resize',
			debounce(() => {
				subscribeFormElement.style.height = `${subscribeFormElement.scrollHeight}px`;
			}, 200),
		);
});
